var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8909 10.8525C15.6118 11.2168 15.1822 11.4344 14.7234 11.4438C14.2655 11.4318 13.8372 11.2147 13.5569 10.8525",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4433 10.8525C10.1645 11.2165 9.73531 11.4341 9.27686 11.4438C8.81871 11.4318 8.39014 11.2147 8.10938 10.8525",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 20.3365C15.7547 20.3347 19.0443 17.8225 20.0345 14.2009C21.1563 14.0787 22.006 13.1314 22.006 12.003C22.006 10.8746 21.1563 9.9273 20.0345 9.80509C19.0469 6.18158 15.7559 3.6676 12.0002 3.6676C8.24448 3.6676 4.95354 6.18158 3.96585 9.80509C2.84411 9.9273 1.99438 10.8746 1.99438 12.003C1.99438 13.1314 2.84411 14.0787 3.96585 14.2009C4.95607 17.8225 8.24573 20.3347 12.0002 20.3365Z",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.223 15.0082C12.9493 16.1194 11.0508 16.1194 9.7771 15.0082",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8887 7.18898C11.2116 7.42452 11.6005 7.55229 12.0001 7.55413C13.0573 7.53016 13.9018 6.66627 13.9018 5.60882C13.9018 4.55137 13.0573 3.68749 12.0001 3.66351",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChild);
export default __webpack_public_path__ + "static/media/child.014c55b892b50213ef6e3372ac6dcc49.svg";
export { ForwardRef as ReactComponent };